import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";

interface IUseFeatureFlagOptions {
  defaultValue?: boolean;
}

export interface IUseFeatureFlagProps {
  featureFlagId?: string;
  featureFlagValue?: string | boolean;
  options?: IUseFeatureFlagOptions;
}

export default function useFeatureFlag(props: IUseFeatureFlagProps) {

  const posthog = usePostHog();
  const [ isFeatureFlagActive, setIsFeatureFlagActive ] = useState(props.options?.defaultValue ?? false);
  const { featureFlagId, featureFlagValue } = props;

  useEffect(() => {
    const updateCanDisplay = () => {
      if (!featureFlagId?.length) {
        return;
      }
      if (!posthog) {
        return;
      }
      const flagValue = posthog.getFeatureFlag(featureFlagId);
      setIsFeatureFlagActive(flagValue === featureFlagValue);
    };

    if (!posthog) {
      return;
    }

    updateCanDisplay();
    posthog.onFeatureFlags(updateCanDisplay);
  }, [ posthog, featureFlagId, featureFlagValue ]);

  return {
    isFeatureFlagActive,
  };

}
